'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reactRouter = require('react-router');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _bodyScrollLock = require('body-scroll-lock');

var _components = require('../../components');

var _MobileMenuItem = require('./HeaderComponents/MobileMenuItem');var _MobileMenuItem2 = _interopRequireDefault(_MobileMenuItem);
var _LanguageSwitch = require('../LanguageSwitch/LanguageSwitch');var _LanguageSwitch2 = _interopRequireDefault(_LanguageSwitch);

var _constants = require('../../constants');
var _analyticsManager = require('../../utils/analytics/analyticsManager');
var _analyticsConstants = require('../../utils/analytics/analyticsConstants');
var _checkUserAgent = require('../../utils/checkUserAgent');var _checkUserAgent2 = _interopRequireDefault(_checkUserAgent);
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _HeaderMobileRenderRules = require('./HeaderMobileRenderRules');
var _checkMobileAgent = require('../../helpers/checkMobileAgent');

var _HeaderMobile = require('./HeaderMobile.scss');var styles = _interopRequireWildcard(_HeaderMobile);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var HeaderMobile = function (_Component) {_inherits(HeaderMobile, _Component);function HeaderMobile() {var _temp, _this, _ret;_classCallCheck(this, HeaderMobile);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { showBackButton: false,
      dropdownProperty: null }, _this.





















































    handleOpen = function () {
      if (!_this.props.isMobileMenuOpen) {
        return _this.props.openMobileHeader();
      }

      if (_this.closeTimeout) {
        return false;
      }

      var menu = document.querySelector('.' + styles['open-menu']);
      if (menu) {
        menu.classList.remove(styles['open-menu']);
      }
      _this.props.hideMobileHeader();

      return true;
    }, _this.

    handleUserAuth = function (selectedTab) {
      _this.props.hideMobileHeader();
      _this.closeMenu();
      _this.props.switchAuthModalType({
        bodyType: _constants.authenticationModalType.DEFAULT,
        selectedTab: selectedTab });

      _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/' + selectedTab));
    }, _this.

    closeMenu = function () {return document.body.classList.remove(styles['open-mobile-menu']);}, _this.

    openUserAuthOverlay = function (selectedTab) {
      _this.props.openAuthenticationModal({ selectedTab: selectedTab });
      var modalName = selectedTab === _constants.userAuthenticationTabs.SIGN_IN ? 'login' : 'register';

      (0, _analyticsManager.trackModalOpen)(modalName);
    }, _this.

    handlePublishClick = function (evt) {
      var canPublish = _this.props.publishClicked(evt);

      if (canPublish) {
        _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/publish'));
      }
    }, _this.

    handleForeignPublishClick = function (evt) {
      var canPublish = _this.props.publishClicked(evt);

      if (canPublish) {
        _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/foreign_publish'));
      }
    }, _this.

    handleSaveDraft = function () {
      var field = _this.props.isForeignDraft ? 'publishForeignData' : 'publishData';

      _this.props.savePublishDraft(field);
    }, _this.

    clickHome = function (event) {
      if (_this.props.isMobileFiltersOpen) {
        _this.props.hideMobileFilters();
      }
      if (_this.props.isHomePage) {
        event.preventDefault();
        global.window.location.reload();
      }
    }, _this.

    handleClickBack = function () {
      if (_this.props.isMobileFiltersOpen) {
        _this.props.hideMobileFilters();
      } else {
        var pagesWithPreview = ['manage_properties', 'publish', 'realtor'];
        if (pagesWithPreview.indexOf(_this.props.location) !== -1) {
          _this.props.hideDetailsPopup();
        } else {
          _reactRouter.browserHistory.goBack();
        }
      }
    }, _this.

    toggleFavoritesSearch = function (status) {var optionType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'buy';
      var path = '/homes/' + optionType + (status ? '/fav' : '');
      (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.searchResults, _analyticsConstants.eventAction.click, _analyticsConstants.eventLabel.favorites);
      _this.props.setFavoritesListState(status).
      then(function () {
        _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, path));
        _this.props.hideMobileHeader();
      });
    }, _this.

    backButtonRequired = function () {var _this$props =
      _this.props,location = _this$props.location,route = _this$props.route,isPreview = _this$props.isPreview,isDetailsModalOpen = _this$props.isDetailsModalOpen;
      var isHomeDetails = location === 'home_details' || _this.props.isDetailsModalOpen;
      var isProjectDetails = location === 'project_details';
      var propertyDetailsPage = location === 'property';
      var routeParams = route.split('/');
      var articlePage = location === 'articles' && routeParams[routeParams.length - 1] !== 'articles';
      var directLink = global.history && global.history.length <= 2;
      var isFBHomeDetails = (0, _checkMobileAgent.isFacebookApp)((0, _checkMobileAgent.getUserAgent)()) &&
      isHomeDetails && global.history && global.history.length <= 2;

      return (
        isFBHomeDetails ||
        isHomeDetails && !directLink ||
        _this.props.isMobileFiltersOpen ||
        propertyDetailsPage ||
        isProjectDetails ||
        isDetailsModalOpen && isPreview ||
        articlePage && !directLink ||
        _this.state.showBackButton);

    }, _this.

    defaultClickHandler = function () {
      _this.props.hideMobileHeader();
    }, _this.

    fetchClickHandler = function (menuItemName) {
      switch (menuItemName) {
        case 'homePage':return _this.clickHome;
        case 'publishProperty':return _this.props.publishClicked;
        case 'foreignPublishProperty':return _this.props.publishClicked;
        case 'signIn':return function () {return _this.handleUserAuth(_constants.userAuthenticationPageTabs.SIGN_IN);};
        case 'newAccount':return function () {return _this.handleUserAuth(_constants.userAuthenticationPageTabs.SIGN_UP);};
        case 'logOut':return _this.props.logOut;
        case 'favorites':return function () {return _this.toggleFavoritesSearch(true);};
        case 'search':return function () {return _this.toggleFavoritesSearch(false);};
        case 'forSale':return function () {return _this.toggleFavoritesSearch(false);};
        case 'forRent':return function () {return _this.toggleFavoritesSearch(false, 'rent');};
        default:return _this.defaultClickHandler;}

    }, _this.

    renderItem = function (_ref) {var title = _ref.title,iconName = _ref.iconName,link = _ref.link,clickHandler = _ref.clickHandler,url = _ref.url,isNew = _ref.isNew;return (
        _react2.default.createElement(_MobileMenuItem2.default, {
          key: title,
          leads: _this.props.leadsNumber,
          translate: _this.props.translate,
          title: title,
          iconName: iconName,
          link: link,
          url: url,
          isNew: isNew,
          additionalProps: clickHandler ? { onClick: clickHandler } : {} }));}, _this.



    renderMenuBlock = function (items) {
      var blockItems = items.map(function (item) {
        var handler = _this.fetchClickHandler(item);
        var data = (0, _HeaderMobileRenderRules.fetchMenuItemData)(item, handler);
        var link = data.link ? (0, _appendLocale2.default)(_this.props.locale, data.link) : '';

        return _this.renderItem(Object.assign({}, data, { link: link }));
      });

      return (
        _react2.default.createElement('div', { className: styles.menuBlock },
          blockItems));


    }, _this.



















































    renderPublishButton = function () {
      var isForeign = (0, _get2.default)(_this.props, 'userAuthentication.publish_permissions.foreign');
      var isRegular = (0, _get2.default)(_this.props, 'userAuthentication.publish_permissions.regular');var
      routeData = _this.props.routeData;

      var isEditPage = routeData.route.includes('property/edit') ||
      routeData.route.includes('foreign_property/edit') ||
      routeData.route.includes('project/edit');

      if (_this.props.canSavePublishDraft) {
        return (
          _react2.default.createElement('button', {
              className: styles.saveDraftButton,
              onClick: _this.handleSaveDraft },

            _this.props.translate('header', _this.props.publishDraftSaved ? 'saved' : 'saveDraft')));


      }

      if (isForeign && isRegular) {
        var dropdownProperty = void 0;

        var getDropdownPropertyRef = function getDropdownPropertyRef(ref) {dropdownProperty = ref;};
        var getRoute = function getRoute(route) {return function () {_reactRouter.browserHistory.push(route);};};
        var openDropdownProperty = function openDropdownProperty() {return dropdownProperty && dropdownProperty.click();};

        return (
          _react2.default.createElement(_components.MenuDropdownProperty, {
            isDisabled: isEditPage,
            triggerIds: ['publishPropertyButtonTitle', 'publishPropertyButton'],
            innerRef: getDropdownPropertyRef,
            translate: _this.props.translate,
            onClick: openDropdownProperty,
            getRoute: getRoute,
            locale: _this.props.locale,
            isMobile: true }));


      }

      return _this.props.isForeignPublish ?

      _react2.default.createElement(_components.PublishPropertyButton, {
        title: '' + _this.props.translate('header', 'publishProperty'),
        theme: 'foreign',
        size: 'small',
        onClick: _this.handleForeignPublishClick,
        isDisabled: isEditPage }) :


      _react2.default.createElement(_components.PublishPropertyButton, {
        title: '' + _this.props.translate('header', 'publishProperty'),
        theme: 'primary',
        size: 'small',
        onClick: _this.handlePublishClick,
        isDisabled: isEditPage });


    }, _this.


    renderLinkLogo = function () {return (
        _react2.default.createElement(_reactRouter.Link, { className: styles.headerBigLogo, to: (0, _appendLocale2.default)(_this.props.locale, '/') },
          _react2.default.createElement('img', {
            src: _constants.onMapLogoBlue,
            onClick: _this.clickHome,
            alt: '' })));}, _this.




    renderSearchIcon = function () {
      var isForeign = _this.props.routeData.location === 'foreign';

      if (!isForeign && !_this.props.isFullLogo) {
        return (
          _react2.default.createElement(_reactRouter.Link, { className: styles.searchButton, to: (0, _appendLocale2.default)(_this.props.locale, '/homes/buy') },
            _react2.default.createElement('span', { className: 'icon icon-search' })));


      }

      return null;
    }, _this.

    renderHomePageContent = function () {return (
        _react2.default.createElement('div', { className: styles.homePageContent },
          _this.renderLinkLogo(),
          _this.renderPublishButton(),
          _this.renderSearchIcon()));}, _temp), _possibleConstructorReturn(_this, _ret);}HeaderMobile.prototype.componentWillMount = function componentWillMount() {this.location = this.props.location;};HeaderMobile.prototype.componentDidMount = function componentDidMount() {var _navigator = navigator,userAgent = _navigator.userAgent;this.isIPhone7 = _checkUserAgent2.default.isIPhone(userAgent) && _checkUserAgent2.default.getIOsVersion(userAgent) === 10;this.isIOsDevice = !!_checkUserAgent2.default.getIOsVersion(userAgent);this.isAndroidDevice = _checkUserAgent2.default.isAndroid(userAgent);};HeaderMobile.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {var _this2 = this;if (newProps.locale !== this.props.locale) {this.props.hideMobileHeader();}if (!this.props.isMobileMenuOpen && newProps.isMobileMenuOpen) {this.menuRef.scrollTop = 0;(0, _bodyScrollLock.disableBodyScroll)(this.menuRef);document.body.classList.add(styles['open-mobile-menu']);}if (this.props.isMobileMenuOpen && !newProps.isMobileMenuOpen) {this.closeTimeout = setTimeout(function () {(0, _bodyScrollLock.enableBodyScroll)(_this2.menuRef);_this2.closeTimeout = null;_this2.closeMenu();}, 350);}if (newProps.location !== this.props.location) {if (this.props.location === 'company' && newProps.location === 'home_details') {this.setState({ showBackButton: true });} else {this.setState({ showBackButton: newProps.location === 'company' && (this.props.location === 'professionals' || this.props.location === 'home_details') });}if (newProps.location === this.location) {this.setState({ showBackButton: false });}}};HeaderMobile.prototype.componentWillUnmount = function componentWillUnmount() {(0, _bodyScrollLock.clearAllBodyScrollLocks)();};HeaderMobile.prototype.renderMenu = function renderMenu() {var _cx,_this3 = this;var isForeign = (0, _get2.default)(this.props, 'userAuthentication.publish_permissions.foreign');var isRegular = (0, _get2.default)(this.props, 'userAuthentication.publish_permissions.regular');var publishBlock = this.renderMenuBlock(_HeaderMobileRenderRules.menuBlocksRules.publishProperty);if (isForeign && isRegular) {publishBlock = this.renderMenuBlock(_HeaderMobileRenderRules.menuBlocksRules.foreignIsraelPublishProperty);} else if (isForeign && !isRegular) {publishBlock = this.renderMenuBlock(_HeaderMobileRenderRules.menuBlocksRules.foreignPublishProperty);}var headBlock = this.renderMenuBlock(_HeaderMobileRenderRules.menuBlocksRules.header);var searchBlock = this.renderMenuBlock(_HeaderMobileRenderRules.menuBlocksRules.search);var userAuthBlockType = this.props.userIsAuthorized ? 'userAuthorized' : 'userNotAuthorized';var authBlockTypePrefix = this.props.userHasProperties ? 'WithProperties' : '';var authBlockCompanyPrefix = this.props.userHasCompany ? 'WithCompany' : '';var authBlockMyStaffPrefix = this.props.isCanCreateStaff ? 'WithMyStaff' : '';var authBlockUserStaffPrefix = (0, _get2.default)(this.props, 'userData.data.assigned_to_agency_id') ? 'WithUserStaff' : '';var userAuthenticationBlock = this.renderMenuBlock(_HeaderMobileRenderRules.menuBlocksRules[userAuthBlockType + authBlockTypePrefix + authBlockCompanyPrefix + authBlockMyStaffPrefix + authBlockUserStaffPrefix]);var iOSBlock = this.isIOsDevice && this.renderMenuBlock(_HeaderMobileRenderRules.menuBlocksRules.iOsApplication);var androidBlock = this.isAndroidDevice && this.renderMenuBlock(_HeaderMobileRenderRules.menuBlocksRules.androidApplication);var footerBlock = this.renderMenuBlock(_HeaderMobileRenderRules.menuBlocksRules.footer);return _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.dropMenu, (_cx = {}, _cx[styles['open-menu']] = this.props.isMobileMenuOpen, _cx)), ref: function ref(_ref2) {_this3.menuRef = _ref2;} }, headBlock, publishBlock, userAuthenticationBlock, searchBlock, footerBlock, iOSBlock, androidBlock, _react2.default.createElement('div', { className: styles.menuBlock }, _react2.default.createElement('div', { className: styles.menuItem }, _react2.default.createElement(_LanguageSwitch2.default, { locale: this.props.locale }))));};HeaderMobile.prototype.



  render = function render() {var _ref3, _cx2;
    var isHomePageStyles = this.props.isHomePageStyles;
    var event = global.window && 'ontouchstart' in window ? 'onTouchStart' : 'onClick';

    var menuBurger = this.backButtonRequired() ?
    _react2.default.createElement('div', { className: styles.btnContainer, onClick: this.handleClickBack },
      _react2.default.createElement('span', { className: styles.buttonBack },
        _react2.default.createElement('span', { className: 'icon icon-' + (this.props.isRtl ? 'next' : 'prev') }))) :



    _react2.default.createElement('div', _extends({ className: styles.btnContainer }, (_ref3 = {}, _ref3[event] = this.handleOpen, _ref3)),

      _react2.default.createElement('span', { className: styles.btnToggle },
        _react2.default.createElement('span', { className: styles.navIcon },
          _react2.default.createElement('span', null),
          _react2.default.createElement('span', null),
          _react2.default.createElement('span', null),
          _react2.default.createElement('span', null))));





    return (
      _react2.default.createElement('header', {
          className: (0, _classnames2.default)(
          styles.mobileMenu, (_cx2 = {}, _cx2[

          styles.withoutTransition] = !this.props.isMobileMenuOpen || this.props.isMobileFiltersOpen, _cx2[
          styles.iconsPadded] = this.isIPhone7, _cx2[
          styles.lowOrder] = this.props.isModalContactsOpen, _cx2)),


          id: isHomePageStyles && !this.props.isMobileFiltersOpen ? 'header_home_page' : '' },

        menuBurger,
        this.renderHomePageContent(),
        this.renderMenu()));


  };return HeaderMobile;}(_react.Component);


HeaderMobile.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  isFullLogo: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  isPreview: _propTypes2.default.bool,
  route: _propTypes2.default.string.isRequired,
  location: _propTypes2.default.string,
  userIsAuthorized: _propTypes2.default.bool,
  openAuthenticationModal: _propTypes2.default.func,
  logOut: _propTypes2.default.func,
  isMobileFiltersOpen: _propTypes2.default.bool,
  hideMobileFilters: _propTypes2.default.func,
  isMobileMenuOpen: _propTypes2.default.bool,
  openMobileHeader: _propTypes2.default.func,
  hideMobileHeader: _propTypes2.default.func,
  userHasProperties: _propTypes2.default.bool,
  userHasCompany: _propTypes2.default.bool,
  isDetailsModalOpen: _propTypes2.default.bool,
  hideDetailsPopup: _propTypes2.default.func,
  setFavoritesListState: _propTypes2.default.func,
  publishClicked: _propTypes2.default.func.isRequired,
  isRtl: _propTypes2.default.bool,
  isHomePage: _propTypes2.default.bool,
  isHomePageStyles: _propTypes2.default.bool,
  isModalContactsOpen: _propTypes2.default.bool,
  savePublishDraft: _propTypes2.default.func,
  publishDraftSaved: _propTypes2.default.bool,
  canSavePublishDraft: _propTypes2.default.bool,
  isForeignPublish: _propTypes2.default.bool,
  userToken: _propTypes2.default.string,
  leadsNumber: _propTypes2.default.number,
  userAuthentication: _propTypes2.default.object,
  routeData: _propTypes2.default.object,
  isCanCreateStaff: _propTypes2.default.object,
  isForeignDraft: _propTypes2.default.bool,
  userData: _propTypes2.default.object,
  switchAuthModalType: _propTypes2.default.func };


var mapStateToProps = function mapStateToProps(state) {return {
    userToken: (0, _get2.default)(state, 'userAuthentication.data.access_token'),
    userAuthentication: (0, _get2.default)(state, 'userAuthentication.data'),
    userData: state.userAuthentication,
    isCanCreateStaff: state.userAuthentication.isCanCreateStaff,
    leadsNumber: state.leads.numberUnreadLeads };};exports.default =


(0, _reactRedux.connect)(mapStateToProps)(
HeaderMobile);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/HeaderMobile.js
// module id = 2648
// module chunks = 0